import { Button, Slide } from '@material-ui/core'
import styled, { css } from 'styled-components'

import { colors } from '@/theme'
import * as medias from '@/consts/medias'

const defaultContainerStyles = css`
  display: flex;
  flex-direction: column;
`

const pageContainerVariantStyles = {
  default: css`
    background-color: ${colors.white};
  `,
  transparent: css`
    background-color: ${colors.background};
    padding: 0.875rem;
  `,
}

export const StyledPageContainer = styled.div`
  ${defaultContainerStyles}
  ${(props) => pageContainerVariantStyles[props.variant]};
`

export const StyledPageHeader = styled.header`
  padding-bottom: 0.25rem;
  border-bottom: 2px solid ${colors.color100};

  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  h3 {
    color: ${colors.color700};
    font-size: 1.2rem;

    display: flex;
    align-items: center;

    .MuiSvgIcon-root {
      font-size: 1rem;
    }
  }

  button {
    margin-right: 0.25rem;
  }

  @media print {
    display: none;
  }

  @media ${medias.sm} {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;

    h3 {
      font-size: 1rem;
    }
  }
`

export const StyledSlideContainer = styled.aside`
  position: relative;
  z-index: 10;
  max-width: 28%;

  @media (min-width: 700px) {
    width: 100%;

    &.closed {
      transition: ease 400ms;
      width: 0;
    }
  }

  @media ${medias.sm} {
    position: fixed;
    top: 60px;
    max-width: calc(100vw - 2rem);
    z-index: 10;

    &::before {
      content: '';
      z-index: -1;
      position: fixed;
      inset: 0;
      background-color: rgba(0, 0, 0, 0.25);
    }

    &.closed {
      z-index: -1;

      &::before {
        visibility: hidden;
      }
    }
  }
`

export const StyledSlide = styled(Slide)`
  margin: 1rem;
  padding: 0.25rem;
  overflow: auto;

  background-color: ${colors.white};
  border-radius: 4px;

  @media ${medias.md} {
    margin-top: 1.25rem;
    margin-left: 4px;
    margin-right: 0;

    box-shadow: 0 2px 15px 2px rgba(0, 0, 0, 0.15);
  }
`

export const OpenSidebarButton = styled(Button)`
  position: fixed;
  z-index: 10;
  transition: 100ms ease-in;
  animation: show-sidebar-button 500ms forwards;

  top: 50%;
  left: -1rem;

  border-radius: 0 5px 5px 0;
  background-color: ${colors.color700};
  color: ${colors.white};

  &:hover {
    background-color: ${colors.color600};
  }

  @keyframes show-sidebar-button {
    from {
      left: -100px;
    }
    to {
      left: 0;
    }
  }
`

export const StyledPageBody = styled.div`
  display: flex;
`

const pageContentVariantStyles = {
  default: css`
    background-color: ${colors.white};
    margin-top: 1rem;
  `,
  transparent: css`
    background-color: ${colors.background};
    padding: 0.875rem;
  `,
}

export const StyledPageContent = styled.section`
  ${(props) => pageContentVariantStyles[props.variant]};
  padding: 12px 14px;
  position: relative;

  width: 100%;
  padding-bottom: 0.5rem;
  z-index: 8;

  transition: width 200ms ease-in;
  overflow: auto;

  &.loading {
    overflow: hidden;
  }

  @media ${medias.lg} {
    height: calc(100vh - 250px);
    /* height: calc(100vh - 214px); */
  }

  @media print {
    border: 1px solid ${colors.color100};
    margin-top: -100px;
  }
`

export const LoaderContainer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 9;

  display: flex;
  justify-content: center;
  align-items: center;

  background: rgba(255, 255, 255, 0.45);
  height: 100%;
`
